import * as types from './mutation-types'

export const fetchFinancialFacilities = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/financialFacilities`, { params }).then((response) => {
            commit(types.SET_FINANCIAL_FACILITIES, response.data.financialfacilities.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const addFinancialFacility = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/financialFacilities', data).then((response) => {
            commit(types.ADD_FINANCIAL_FACILITY, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const updateFinancialFacility = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/financialFacilities/${data.id}`, data).then((response) => {
            if (response.data.result == 'true') {
                commit(types.UPDATE_FINANCIAL_FACILITY, response.data)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const fetchFinancialFacilityByUser = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/financialFacilities/getFacilityByUser`, data).then((response) => {
          if(response.data.result == true){
            commit(types.SET_FINANCIAL_FACILITIES, response.data.financialfacilities)
          }
          resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const unsetFinancialFacilities = ({ commit, dispatch, state }, data) => {
    commit(types.SET_FINANCIAL_FACILITIES, [])
}
